var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"q-mr-sm",staticStyle:{"display":"inline-block"}},[_vm._v(" "+_vm._s(_vm.getTrapInfo(JSON.parse(_vm.data.props.row.extendedData)))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }